import request from '@/plugins/request'

export function getGapList(ym, pageindex, pagesize) {
    return request({
        url: '/v1/Gap/GetGapList',
        method: 'post',
        data: {
            yearMonth: ym,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}